import {DataStrategy} from './DataStrategy';
import {GnTableComponent} from './table.component';

export class RemoteDataStrategy implements DataStrategy {

  constructor(private table: GnTableComponent) {
  }

  load(): Promise<any> {
    if (!this.table.url) {
      return Promise.resolve(null);
    }

    const queryParameter = {
      pageSize: this.table.pageSize,
      pageIndex: this.table.pageIndex - 1,
      includes: this.table.includes || [],
      sorts: this.table.sorts,
      filterGroup: this.table.filterGroup
    };
    return this.table.http.post(this.table.url, queryParameter)
      .toPromise();
  }

  delete(url: string, id: any[]): Promise<any> {
    this.table.isLoading = true;
    return this.table.http.request('delete', url, {body: id})
      .toPromise();
  }

  save(url: string, data: any): Promise<any> {
    return this.table.http.put(this.table.url, data)
      .toPromise();
  }
}
